import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { EventData } from '../../../../models/manager-content-vehicle-history-drawer.model';

@Component({
  selector: 'events-history-list',
  templateUrl: './events-history-list.component.html',
  styleUrls: ['./events-history-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventsHistoryListComponent {
  @Input() events: EventData[] = [];
  @Input() currentImei: string = '';
  @Input() currentState: Map<string, Map<string, boolean>> = new Map();
  @Output() selectCard = new EventEmitter<any>();
  @Output() redirectTo = new EventEmitter<string>();

  readonly itemSize = 120; // Altura fija para eventos

  isCardSelected(id: number, type: string, variant: string = 'stop'): boolean {
    const currentImei = this.currentImei;
    if (!currentImei) return false;

    const imeiMap = this.currentState.get(currentImei);
    if (!imeiMap) return false;

    const key = `${id}-${type}-${variant}`;
    return imeiMap.get(key) ?? false;
  }

  trackByEventId(index: number, event: EventData): string {
    return event.id?.toString() || `${event.imei}-${event.fecha_tracker}`;
  }

  onSelectCard(event: any): void {
    this.selectCard.emit(event);
  }

  onRedirectTo(type: string): void {
    this.redirectTo.emit(type);
  }

  get isEmpty(): boolean {
    return !this.events || this.events.length === 0;
  }

  get emptyMessage(): string {
    return 'No hay eventos registrados en este período de tiempo';
  }

  get suggestionMessage(): string {
    return '¿Te gustaría revisar los frames o paradas del vehículo?';
  }
}
